<template>
  <div v-if="options.length !== 0" class="select">
    <div class="select-field" @click="focus = true">
      {{ title }}
    </div>
    <div v-if="focus" class="select-frame">
      <div
        class="select-option"
        v-for="(o, index) in options"
        :key="index"
        @click="selectOption(o)">
        {{ o.get(name) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      required: true
    },

    select: {
      type: Function
    },

    options: {
      type: Array,
      required: true
    },

    name: {
      type: String,
      default: function () {
        return 'ja'
      }
    }
  },

  data () {
    return {
      focus: false
    }
  },

  computed: {
    title: function () {
      if (!this.option) {
        return ''
      }
      const option = this.options.find((o) => {
        return o.id === this.option.id
      })

      if (option) {
        return option.get(this.name)
      }
      return ''
    }
  },

  methods: {
    selectOption: function (o) {
      if (this.select) {
        this.select()
      }
      this.focus = false
      this.$emit('select', o)
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 100%;

  &-field {
    @include input-select;
  }

  &-frame {
    @include input-select-frame;
  }

  &-option {
    @include input-select-option;
  }
}
</style>
